export default "__VITE_ASSET__BMMqG46K__"